import axiosInstance from '../axiosInstance';

// تصدير كل دالة على حدة
export const login = async (credentials) => {
  try {    
    const response = await axiosInstance.post('/api/v1/accounts/login', {
      email: credentials.email,
      password: credentials.password
    });

     // تخزين التوكن مباشرة هنا
     if (response.data.token) {
      localStorage.setItem("token", response.data.token);
      // تخزين نوع المستخدم أيضاً إذا كان موجوداً
      if (response.data.userType) {
        localStorage.setItem("userType", response.data.userType);
      }
    }
    
    return response;
  } catch (error) {
    console.error('Login API error:', error);
    throw error;
  }
};

export const signUp = async (userData) => {
  try {
    const response = await axiosInstance.post('/api/v1/accounts/signup', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendConfirmEmail = async (email) => {
  try {
    const response = await axiosInstance.post('/api/v1/accounts/send-confirm-email', { email });
    return response.data;
  } catch (error) {
    console.error('Send confirmation email error:', error);
    throw error;
  }
};

export const confirmEmail = async (userId, token) => {
  try {
    const response = await axiosInstance.post('/api/v1/accounts/confirm-email', { userId, token });
    return response.data;
  } catch (error) {
    console.error('Confirm email error:', error);
    throw error;
  }
};

export const sendResetPasswordCode = async (email) => {
  try {
    const response = await axiosInstance.post('/api/v1/accounts/send-reset-password-code', {
      email: email
    });
    
    return response;
    
  } catch (error) {
    console.error('Reset password error:', error);
    throw error;
  }
};

export const resetPassword = async (resetData) => {
  try {
    const response = await axiosInstance.post('/api/v1/accounts/reset-password', {
      email: resetData.email,
      password: resetData.password,
      confirmPassword: resetData.confirmPassword,
      code: resetData.code
    });
    
    return response;
  } catch (error) {
    console.error('Reset password error:', error);
    throw error;
  }
};

// export const changePassword = async (changePasswordData) => {
//   try {
//     const response = await axiosInstance.post('/auth/change-password', changePasswordData);
//     return response.data;
//   } catch (error) {
//     console.error('Change password error:', error);
//     throw error;
//   }
// };

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userId');
  delete axiosInstance.defaults.headers.common['Authorization'];
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const getUserId = () => {
  return localStorage.getItem('userId');
};

// تصدير افتراضي لجميع الدوال معاً
const auth = {
  login,
  signUp,
  sendConfirmEmail,
  confirmEmail,
  sendResetPasswordCode,
  resetPassword,
  // changePassword,
  logout,
  isAuthenticated,
  getUserId
};

export default auth;
